import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { Participation, ParticipationStatus } from '@app/api';
import { FormatSimpleIcon, Chip } from 'components';
import moment from 'moment-timezone';

const useStyles = createUseStyles((theme: Theme) => ({
  formatIcon: {
    marginRight: theme.marginBase,
  },
}));

interface Props {
  participation: Participation;
  className?: string;
}

export const ParticipationDateChip = ({ participation, className }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  const appointment =
    participation.appointment || participation.cancelledAppointment;
  if (!appointment) {
    return null;
  }

  const { status } = participation;
  return (
    <Chip
      color={
        status !== ParticipationStatus.BOOKED ||
        appointment === participation.cancelledAppointment
          ? 'inkSecondary'
          : 'green'
      }
      className={className}
    >
      {participation.format && (
        <FormatSimpleIcon
          format={participation.format}
          className={classes.formatIcon}
        />
      )}
      {moment(appointment.date).format('l')} -{' '}
      {moment(appointment.date).format('LT')}
    </Chip>
  );
};
